import React from 'react';
import { observer } from 'mobx-react';

import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

import { AuctionFinalsMatrix } from 'components/AuctionFinals/components';

import { localizable } from 'components/Localization';

import BaseStep from '../components/BaseStep';

@localizable
@observer
class AwardAllStep1 extends BaseStep {
  componentDidMount() {
    const { store, onValidChanged } = this.props;

    onValidChanged(store.auctionFinalsStore.selectedCount > 0);
    store.auctionFinalsStore.onSelectionChanged = this.handleSelectionChanged;

    if (!store.loaded) {
      store.loading = true;
      store.auctionFinalsStore.load().then((result) => {
        store.loading = false;
        store.loaded = true;
      });
    }
  }

  componentWillUnmount() {
    const { store } = this.props;
    store.auctionFinalsStore.onSelectionChanged = null;
  }

  handleSelectionChanged = (selection) => {
    const { store, onValidChanged } = this.props;
    onValidChanged(store.auctionFinalsStore.selectedCount > 0);
  };

  render() {
    const { store, t } = this.props;
    const { sale } = store.auctionFinalsStore;

    return (
      <div style={{ width: '100%', minHeight: '50px' }}>
        {store.loading && (
          <Spinner
            label={`${t('Loading offers, please wait')}...`}
            size={SpinnerSize.medium}
          />
        )}
        {store.loaded && (
          <div>
            <AuctionFinalsMatrix
              sale={sale}
              store={store.auctionFinalsStore}
              locale={sale.saleEdit.locale}
              currency={sale.saleEdit.currencyCode}
            />
          </div>
        )}
      </div>
    );
  }
}

export default AwardAllStep1;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/AwardAll/Step1.jsx